// The tierTCG up/down arrows mark, rendered as inline SVG so it scales cleanly
// and tints via currentColor. Used as a decorative watermark.
export default function UpDownMark({ className = "", style }) {
  return (
    <svg
      viewBox="0 0 100 164"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
    >
      <polygon points="50,0 100,72 0,72" />
      <polygon points="50,164 100,92 0,92" />
    </svg>
  );
}
